/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'dialog';
const componentName = 'message-of-the-day';
const prefix = `${moduleName}.${componentName}`;

export const title = `${prefix}.title`;

export const ENGLISH = {
    [title]: 'Message of the Day',
};
